export class BluechatFindCarrierByDeliveryNumber {
  carrierId: string;
  carrierName: string;
  carrierCode: string;
  carrierBlueyonderCode: string;
  carrierBluechatCode: string;
  deliveryNumbers: string[];
  bluechatEnabled: boolean;
  existsOnCmaWeb: boolean;

  static fromDto(json: any) {
    const res = new BluechatFindCarrierByDeliveryNumber();

    res.carrierId             = json.carrier_id;
    res.carrierName           = json.carrier_name;
    res.carrierCode           = json.carrier_code;
    res.carrierBlueyonderCode = json.carrier_blueyonder_code;
    res.carrierBluechatCode   = json.carrier_bluechat_code;
    res.deliveryNumbers       = json.delivery_numbers;
    res.bluechatEnabled       = json.bluechat_enabled;
    res.existsOnCmaWeb        = json.exists_on_cma_web;

    return res;
  }
}
